import { CCarousel } from './CCarousel.js';
import { CCarouselCaption } from './CCarouselCaption.js';
import { CCarouselItem } from './CCarouselItem.js';

const CCarouselPlugin = {
    install: (app) => {
        app.component(CCarousel.name, CCarousel);
        app.component(CCarouselCaption.name, CCarouselCaption);
        app.component(CCarouselItem.name, CCarouselItem);
    },
};

export { CCarousel, CCarouselCaption, CCarouselItem, CCarouselPlugin };
//# sourceMappingURL=index.js.map
